module.exports = __webpack_public_path__ + "static/video1-ea6325d0c814e97353ee0f551b232b8c.mp4";